import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
    loader: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "var(--bg, rgba(255 255 255 / .7))",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10,
    },
}));

const Loading = ({ loading, bg }) => {
    const styles = useStyles();
    if (!loading) return null;
    return <div style={{ "--bg": bg }} className={styles.loader}>
        <CircularProgress />
    </div>;
};
export default Loading;